module.exports = __webpack_public_path__ + "img/product-banner_11.7a14427f.png";